import gql from 'graphql-tag'

export const CostBuildingFragment = gql`
  fragment CostBuildingFragment on Building {
    id
    name
    city
    floors {
      id
    }
    costs(year: $year) {
      contractId
      annualCostPerEmployee
      annualCostPerSeat
      annualCostPerSqft
      annualLease
      annualOps
      annualTotal
      employeesCount
      occupancy
      spacesCount
      sqft
    }
  }
`
